/* @flow */

import { CLEAR_NOTIFICATIONS, SET_NOTIFICATIONS_READ } from '../constants/actionTypes';
import { fetchFriendRequests } from './friendRequestActions';

export function setNotificationsRead() {
  return {
    type: SET_NOTIFICATIONS_READ
  };
}

export function clearNotifications() {
  return {
    type: CLEAR_NOTIFICATIONS
  };
}

/**
 * Fetch all the notifications...this is a bit of the dodgy way to do it
 * and won't really scale, but for now ¯\_(ツ)_/¯
 */
export function fetchNotifications() {
  return (dispatch: Dispatch<*>) => {
    // load friend requests which we'll get notifications for
    dispatch(fetchFriendRequests());
  };
}
